import React, { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const SnackbarComponent = (props) => {

    const { type, text = "detault text", setOpen, open, bColor="rgb(83, 148, 96)" } = props

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    useEffect(() => {
        if (open) {
            setTimeout(() => {
                setOpen(false)
            }, 5000)
        }
    }, [open])

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar open={open} autoHideDuration={6000}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity={type} sx={{ width: '100%', backgroundColor:bColor  }}>
                    {text}
                </Alert>
            </Snackbar>
        </Stack>
    );
}